<template>
    <div class="form">
        <ValidationObserver ref="form">

            <EducationForm
                :user="user"
                @data-changed="updateForm"
            >
            </EducationForm>

            <div class="row">
                <div class="col-12 text-right ">
                    <div class="wrap-border-top">
                        <div class="btns-wrap">
                            <a href="/application-step-7"
                               class="btn btn--outline-primary w-100 w-sm-auto">Back</a>
                            <a href="javascript:void(0)" @click="save" class="btn btn--secondary w-100 w-sm-auto">Continue</a>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>

    </div>
</template>

<script>

import EducationForm from "../CommonForms/EducationForm.vue";
import ApplicationFormService from "../services/ApplicationFormService";

export default {
    name: 'ApplicantFormStep8',
    components: {EducationForm},
    props: {
        user: {
            type: Object
        }
    },
    data() {
        return {
            dataFormStep8: {}
        }
    },

    methods: {
        save() {
            (async () => {
                const valid = await this.$refs.form.validate();

                if (!valid) {
                    this.$showValidationErrorMessage();
                    return;
                }
                try {
                    const response = await ApplicationFormService.saveStep8(this.dataFormStep8);
                    if (response.status === 200) {
                        this.$showSuccessMessage();
                        setTimeout(() => {
                            window.location.href = '/application-step-9';
                        }, 1000)
                    }
                } catch (error) {
                    this.$handleErrors(error)
                }
            })();
        },
        updateForm(dataEducationForm) {
            this.dataFormStep8 = dataEducationForm;
        }
    },
}

</script>

<style scoped>

</style>
